import { TypedDocumentNode, gql } from '@apollo/client';

import useMutation from '@sorare/core/src/hooks/graphql/useMutation';

import {
  LeaveLeague,
  LeaveLeagueVariables,
} from './__generated__/useLeaveLeague.graphql';

const LEAVE_LEAGUE = gql`
  mutation LeaveLeague($leagueSlug: String!) {
    leaveLeague(slug: $leagueSlug)
  }
` as TypedDocumentNode<LeaveLeague, LeaveLeagueVariables>;

type Props = {
  leagueSlug: string;
};

export default () => {
  const [leagueMutation] = useMutation(LEAVE_LEAGUE);

  return async ({ leagueSlug }: Props) =>
    leagueMutation({
      variables: { leagueSlug },
    });
};
